import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';

import useCodingStore from './CodingStore';

const useStyles = makeStyles((theme) => ({
  timer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
  },
  timerBox: {
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
  }
}));

export const DisplayTimer = ({ timeLeft, warningTime }) => {
  const classes = useStyles();

  const [minutes, setMinutes] = React.useState('00');
  const [seconds, setSeconds] = React.useState('00');
  const [showWarning, setShowWarning] = React.useState(false);

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    setMinutes(mins);
    setSeconds(secs);

    if(seconds <= warningTime){
      setShowWarning(true);
    }else{
      setShowWarning(false);
    }
  };

  React.useEffect(()=>{
    formatTime(timeLeft);
  }, [timeLeft]);

  return (
    <Box className={classes.timer}>
      <Box id='timer' className={classes.timerBox}>
        <Typography
          id='timer-container' variant="h6-semiBold"
          color={showWarning ? 'error.main' : 'primary.main'}
        >
          {minutes}&nbsp;:&nbsp;{seconds}
        </Typography>
      </Box>
    </Box>
  )
}


const Timer = ({ totalTime=0, warningTime=0 }) => {
  const timeLeft = useCodingStore(state => state.timeLeft);
  const setTimeLeft = useCodingStore(state => state.setTimeLeft);
  
  const timeLeftRef = React.useRef(timeLeft);
  
  React.useEffect(()=>{
    setTimeLeft(totalTime);
  }, [totalTime, setTimeLeft]);
  
  React.useEffect(() => {
    timeLeftRef.current = timeLeft;
  }, [timeLeft]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      let newTime = timeLeftRef.current;

      if (newTime <= 1) {
        clearInterval(timer);
        newTime = 0;
      } else {
        newTime = newTime - 1;
      }

      setTimeLeft(newTime);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return(
    <DisplayTimer
      timeLeft={timeLeft}
      warningTime={warningTime}
    />
  )
};

export default Timer;